import request from '@/utils/request'
import axios from 'axios'

// 获取对账列表
export async function api_getFinancePage(params) {
	return request({
		url: '/rest/finance/page',
		method: 'get',
		params,
	})
}
// 获取对账列表
export async function api_getRefundPage(params) {
	return request({
		url: '/rest/refund/page',
		method: 'get',
		params,
	})
}
// 获取对账中心数据
export async function api_getStatementTradeSummaryPage(params) {
	return request({
		url: '/rest/statement/tradeSummary/page',
		method: 'get',
		params,
	})
}

// 对账中心综合统计导出
export async function api_postTradeStatisticsExport(data) {
	return request({
		url: '/rest/statement/tradeStatistics/export',
		method: 'post',
		data,
		responseType: 'blob',
	})
}

// 对账中心-对账列表导出
export async function api_postFinanceExport(data) {
	return request({
		url: '/rest/finance/export',
		method: 'post',
		data,
		responseType: 'blob',
	})
}

// 店铺管理
// 财务-店铺列表
export async function api_getShopList(params) {
	return request({
		url: '/rest/finance/store/page',
		method: 'get',
		params,
	})
}

// 楼层数据
export async function api_getFloorData(data) {
	return request({
		url: '/rest/mall',
		method: 'get',
		data,
	})
}

// 录入店铺
export async function api_postShopAdd(data) {
	return request({
		url: '/rest/finance/store',
		method: 'post',
		data,
	})
}

// 编辑店铺
export async function api_putShopEdit(data) {
	return request({
		url: '/rest/finance/store',
		method: 'put',
		data,
	})
}

// 详情-获取店铺基本信息数据
export async function api_getShopDetailData(params) {
	return request({
		url: '/rest/finance/store',
		method: 'get',
		params,
		loading: true
	})
}

// 查看店铺联系电话
export async function api_getShopPhone(params) {
	return request({
		url: '/rest/finance/store/getPhoneByStoreId',
		method: 'get',
		params,
	})
}

// 查看店铺银行卡号
export async function api_getShopBankcardNo(params) {
	return request({
		url: '/rest/finance/store/getBankCardNo',
		method: 'get',
		params,
	})
}

// 店铺下载收款码
export async function api_getDownloadCode(params) {
	return axios({
		url: '/rest/store/pay/miniCode/download',
		method: 'get',
		params,
		responseType: 'blob',
	})
}

// 修改店铺状态
export async function api_putChangeStatus(params) {
	return request({
		url: '/rest/finance/store/toggle',
		method: 'put',
		params,
	})
}

// 下载店铺导入模板
export async function api_getStoreImportTemplate(params) {
	return request({
		url: '/rest/store/export',
		method: 'get',
		params,
		responseType: 'blob',
	})
}

// 批量导入店铺
export async function api_postBatchImportStore(data) {
	return request({
		url: '/rest/finance/store/batchCreate',
		method: 'post',
		data,
		loading: true
	})
}

//  店铺券码-列表
export async function api_getCouponCodeList(params) {
	return request({
		url: '/rest/market/couponcode/page',
		method: 'get',
		params,
	})
}

//  店铺券码-下载券码
export async function api_postCouponCodeExport(data) {
	return request({
		url: '/rest/market/couponcode',
		method: 'post',
		data,
		responseType: 'blob',
	})
}

//  店铺券码-下载核销记录
export async function api_postCouponCodeRecordExport(data) {
	return request({
		url: '/rest/market/couponcode/export',
		method: 'post',
		data,
		responseType: 'blob',
	})
}

//  店铺券码-下载核销记录
export async function api_postCouponCodeOldExport(data) {
	return request({
		url: '/rest/market/couponcode/old/export',
		method: 'post',
		data,
		responseType: 'blob',
	})
}

// 详情-获取对账信息列表
export async function api_getReconciliationCenterList(params) {
	return request({
		url: '/rest/statement/tradeDetails/page',
		method: 'get',
		params,
		loading: true
	})
}

// 对账信息列表导出
export async function api_postReconciliationExport(data) {
	return axios({
		url: '/rest/statement/tradeDetails/export',
		method: 'post',
		data,
		responseType: 'blob',
	})
}

// 详情-交易类型下拉框数据
export async function api_getTradeType(params) {
	return request({
		url: '/rest/statement/listTradeType',
		method: 'get',
		params,
	})
}

// 详情-支付类型下拉框数据
export async function api_getPayType(params) {
	return request({
		url: '/rest/finance/store/payTypes',
		method: 'get',
		params,
	})
}



// 设置费率
export async function api_postStoreRatio(data) {
	return request({
		url: '/rest/finance/store/ratio',
		method: 'post',
		data
	})
}

// 详情-获取优惠券分摊list
export async function api_getCouponApportionData(params) {
	return request({
		url: '/rest/market/coupon/template/store/cost/list',
		method: 'get',
		params,
	})
}

// 财务管理列表-list
export async function api_getStoreFinancialDetailList(params) {
	return request({
		url: '/rest/statement/storeFinancialDetail/page',
		method: 'get',
		params,
	})
}

// 财务管理列表-导出
export async function api_postStoreFinancialDetailExport(data) {
	return axios({
		url: '/rest/statement/storeFinancialDetail/export',
		method: 'post',
		data,
		responseType: 'blob',
	})
}

// 补贴款审核列表
export async function api_getStoreSubsidyData(params) {
	return axios({
		url: '/rest/store/subsidy/page',
		method: 'get',
		params
	})
}

// 补贴款审核
export async function api_postStoreSubsidyAudit(data) {
	return axios({
		url: '/rest/store/subsidy/audit',
		method: 'post',
		data
	})
}

// 品牌下拉列表
export async function api_getBrandSelectList(params) {
	return request({
		url: '/rest/brand/all',
		method: 'get',
		params
	})
}
// 获取退款审核列表
export async function api_postRefundApplyPage(data) {
	return request({
		url: '/rest/payment/order/refund/apply/page',
		method: 'post',
		data,
	})
}
// 审核退款操作
export async function api_postRefundPage(data) {
	return request({
		url: '/rest/payment/order/refund/apply',
		method: 'put',
		data,
		loading: true
	})
}
// 购卡记录导出
export async function api_postStoredcardExport(data) {
	return axios({
		url: '/rest/finance/store/storecard/export',
		method: 'post',
		data,
		responseType: 'blob',
	})
}

// 储值卡推广码导出
export async function api_postStoredVCCodeExport(params) {
	return axios({
		url: '/rest/finance/store/miniCode/download',
		method: 'get',
		params,
		responseType: 'blob',
	})
}
/**
 * 入网申请
 */
export async function networkAccessApp(rid) {
	return axios({
		url: '/rest/store/networkAccess?id=' + rid,
		method: 'put',
	})
}

//结算分账
export async function api_getStatement(params) {
	return axios({
		url: '/rest/statistics/store/statement/page',
		method: 'get',
		params,
	})
}

//手动结算
export async function api_putSeparateAccounts(storeId,rid) {
	return axios({
		url: '/rest/statistics/store/statement/separateAccountsV2?storeId='+storeId+'&id=' + rid,
		method: 'put',
	})
}

//结算导出
export async function api_postSettlementExport(data) {
	return axios({
		url: '/rest/statistics/store/statement/export',
		method: 'post',
		data,
		responseType: 'blob',
	})
}